"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedAttributesFactory = void 0;
const Factory = require("factory.ts");
exports.extendedAttributesFactory = Factory.Sync.makeFactory({
    key: 'testKey',
    value: 'testValue',
});
